import type { VfConfig } from '#types/config/components/vf'

export default {
  controlSizes: { sm: 'sm', md: 'sm' }
} satisfies VfConfig['video']
